/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import LogOut from "layouts/authentication/log-out";
import ResetPassword from "layouts/authentication/reset-password/cover";
import ResetPasswordWithCode from "layouts/authentication/Reset-password-with-code";
import NewRequest from "layouts/request/new";
import RequestList from "layouts/request/list";
import RequestList2 from "layouts/request/list2";
import RequestList3 from "layouts/request/list3";
import RequestList4 from "layouts/request/list4";
import Home from "layouts/Home";
import CustomSignUp from "layouts/authentication/components/CustomSignUp";

import RequestCategory from "layouts/Request-Category";
import RequestTypes from "layouts/Request-Types";
import Accesses from "layouts/Accesses";
import Messages from "layouts/Messages";
import Company from "layouts/Company";
import Settings from "layouts/Settings";
import ChangePassword from "layouts/Change-password";
import NewRequest2 from "layouts/New-Request";
import RequestDetails from "layouts/Request-Details";
import RequestDetailsViewAll from "layouts/Request-Details-View-all";
import RegisterUsers from "layouts/Register-Users-List";
import SalesReport from "layouts/Sales-Report";
import Subscriptions from "layouts/Subscriptions";

import HeroSection from "layouts/website-content/HeroSection";
import PlatformFeature from "layouts/website-content/PlatformFeature";
import BandihubFeature from "layouts/website-content/BandihubFeature";
import CtaSection from "layouts/website-content/CtaSection";
import FormSettings from "layouts/website-content/FormSettings";
import FooterSection from "layouts/website-content/FooterSection";
import FooterLink from "layouts/website-content/FooterLink";


import Pages from "layouts/Pages";
import PrivacyPolicy from "layouts/privacy-policy";
import CookiePolicy from "layouts/cookie-policy";

// @mui icons
import Icon from "@mui/material/Icon";
import { Table } from "@mui/material";


const routes = [
  // {
  //   type: "collapse",
  //   name: "Dashboard",
  //   key: "dashboard",
  //   icon: <Icon fontSize="small">dashboard</Icon>,
  //   route: "/dashboard",
  //   component: <Dashboard />,
  // },
  {
    type: "collapse",
    name: "Home",
    key: "home",
    // icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/home",
    component: <Home />,
    requiredRole: 'user',
  },
  // {
  //   type: "collapse",
  //   name: "CustomSignUp",
  //   key: "CustomSignUp",
  //   // icon: <Icon fontSize="small">dashboard</Icon>,
  //   route: "/sign-up",
  //   component: <CustomSignUp />,
  //   requiredRole: 'user',
  // },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    // component: <RequestList3 />,
    component: <RequestList4 />,
  },
  // {
  //   type: "collapse",
  //   name: "Pages",
  //   key: "Pages",
  //   icon: <Icon fontSize="small">dashboard</Icon>,
  //   route: "/Pages",
  //   component: <Pages />,

  // },
  {
    type: "collapse",
    name: "cookie-policy",
    key: "cookie-policy",
    icon: <Icon fontSize="small">dashboard</Icon>,
    // route: "/cookie-policy",
    route: "/cookie-policy",
    component: <CookiePolicy />,
    requiredRole: 'user',
  },
  {
    type: "collapse",
    name: "privacy-policy",
    key: "privacy-policy",
    icon: <Icon fontSize="small">dashboard</Icon>,
    // route: "/privacy-policy",
    route: "/privacy-policy",
    component: <PrivacyPolicy />,
    requiredRole: 'user',
  },
  {
    type: "collapse",
    name: "RequestDetailsAll",
    key: "RequestDetailsAll",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/RequestDetailsAll",
    component: <RequestDetailsViewAll />,
    requiredRole: 'user',
  },
  // {
  //   type: "collapse",
  //   name: "Tables",
  //   key: "tables",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/tables",
  //   component: <Tables />,
  // },
  // {
  //   type: "collapse",
  //   name: "Billing",
  //   key: "billing",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/billing",
  //   component: <Billing />,
  // },
  // {
  //   type: "collapse",
  //   name: "RTL",
  //   key: "rtl",
  //   icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
  //   route: "/rtl",
  //   component: <RTL />,
  // },
  // {
  //   type: "collapse",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/profile",
  //   component: <Profile />,
  // },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
    requiredRole: 'user',
  },
  // {
  //   type: "collapse",
  //   name: "Register",
  //   key: "dashboard/register",
  //   icon: <Icon fontSize="small">account_circle</Icon>,
  //   route: "dashboard/register",
  //   component: <SignUp />,
  //   // requiredRole: 'user',
  // },
  {
    type: "collapse",
    name: "Reset Password",
    key: "reset-password",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/reset-password/cover",
    component: <ResetPassword />,
    requiredRole: 'user',
  },
  {
    type: "collapse",
    name: "Reset Code",
    key: "reset-code",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/Reset-password-with-code/",
    component: <ResetPasswordWithCode />,
    requiredRole: 'user',
  },
  {
    type: "collapse",
    name: "New Request",
    key: "new-request",
    icon: <Icon fontSize="small">post_add</Icon>,
    route: "/request/new",
    component: <NewRequest />,
    requiredRole: 'user',
  },
  {
    type: "collapse",
    // name: "Requests",
    name: "Richieste",
    key: "request-list",
    icon: <Icon fontSize="small">description</Icon>,
    route: "/request/list",
    component: <RequestList />,
    requiredRole: 'user',
  },
  {
    type: "collapse",
    name: "Requests Types",
    key: "request-list-types",
    icon: <Icon fontSize="small">description</Icon>,
    route: "/request/requests-types",
    component: <RequestList2 />,
    requiredRole: 'user',
  },
  {
    type: "collapse",
    // name: "Requests",
    name: "Richieste",
    key: "dashboard/Elenco-Richieste",
    // icon: <Icon fontSize="small">description</Icon>,
    icon: <Icon fontSize="small">search</Icon>,
    // route: "dashboard/request-list",
    route: "dashboard/Elenco-Richieste",
    // component: <NewRequest />,
    component: <NewRequest2 />,

  },
  {
    type: "collapse",
    name: "Richieste-Dettagli",
    key: "Richieste-Dettagli",
    icon: <Icon fontSize="small">description</Icon>,
    // route: "/requests-details",
    route: "/Richieste-Dettagli",
    component: <RequestDetails />,
    requiredRole: 'user',
  },
  // {
  //   type: "collapse",
  //   name: "Users",
  //   key: "dashboard/register-users-list",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/dashboard/register-users-list",
  //   component: <RegisterUsers />,
  //   // requiredRole: 'user',
  // },
  {
    type: "collapse",
    // name: "Administration",
    name: "Amministrazione",
    key: "Administration-list",
    // icon: <Icon fontSize="small">description</Icon>,
    icon: <Icon fontSize="small">settings</Icon>,
    // route: "/dashboard/Administration/request-types",
    // component: <ListCategory />,
    collapse: [
      {
        // name: "Types of Requests",
        name: "Tipologia Richieste",
        key: "/dashboard/Administration/request-types",
        // route: "/request-types",
        // route: "/dashboard/Administration/request-types",
        route: "/dashboard/Amministrazione/Tipologia-Richieste",
        component: <RequestTypes />,
      },
      {
        // name: "Types of Requests",
        name: "Accessi",
        key: "/dashboard/Administration/Accesses",
        // route: "/Accessess",
        // route: "/dashboard/Administration/Accesses",
        route: "/dashboard/Amministrazione/Accessi",
        component: <Accesses />,
      },
      {
        // name: "Types of Requests",
        name: "Messaggi",
        key: "/dashboard/Administration/Messages",
        // route: "/Messages",
        // route: "/dashboard/Administration/Messages",
        route: "/dashboard/Amministrazione/Messaggi",
        component: <Messages />,
      },
      {
        // name: "Categories",
        name: "Categorie",
        key: "request-categories",
        // route: "/dashboard/Administration/request-categories",
        route: "/dashboard/Amministrazione/Categoria",
        component: <RequestCategory />,
      },
      {
        name: "Vendite Rapporto",
        key: "sales-rep",
        route: "/dashboard/Amministrazione/Vendite-Rapporto",
        component: <SalesReport />,
      },
      {
        name: "Abbonamento",
        key: "subscriptions",
        route: "/dashboard/Amministrazione/abbonamento",
        component: <Subscriptions />,
      },
      {
        // name: "Companies",
        name: "Aziende",
        key: "companies",
        // route: "/dashboard/Administration/companies",
        route: "/dashboard/Amministrazione/Aziende",
        component: <Company />,
      },
      {

        // name: "Register",
        name: "Registrazione",
        key: "register",
        // route: "/dashboard/Administration/register",
        route: "/dashboard/Amministrazione/Nuovo-utente",
        component: <SignUp />,

      },
      {

        // name: "Users",
        name: "Utenti",
        key: "/dashboard/Administration/register-users-list",
        icon: <Icon fontSize="small">person</Icon>,
        // route: "/dashboard/Administration/register-users-list",
        route: "/dashboard/Amministrazione/Elenco-utenti",
        component: <RegisterUsers />,

      },
      {
        type: "collapse",
        name: "Settings",
        key: "dashboard/settings",
        icon: <Icon fontSize="small">settings</Icon>,
        route: "/dashboard/settings",
        component: <Settings />,
        requiredRole: 'suser',
      },
      {
        // name: "Change Password",
        name: "Cambio password",
        key: "change-password",
        // route: "/dashboard/Administration/change-password",
        route: "/dashboard/Administration/Cambio-Password",
        component: <ChangePassword />,
      },

      // {
      //   name: "New Request2",
      //   key: "new-request2",
      //   route: "/new-request2",
      //   component: <NewRequest2 />,
      // },
    ],
    // requiredRole: 'user',
  },
  {
    type: "collapse",
    // name: "Contenuto del Sito",
    // key: "website-content",
    name: "Casa",
    key: "casa-content",
    icon: <Icon fontSize="small">web</Icon>,
    collapse: [
      {
        // name: "Hero Section",
        // key: "hero-section",
        name: "Banner Section",
        key: "banner-section",
        route: "/dashboard/Casa/Banner-Section",
        component: <HeroSection />,  // You need to import this
      },
      {
        name: "Platform Features",
        key: "platform-features",
        route: "/dashboard/Casa/Platform-Features",
        component: <PlatformFeature />, // You need to import this
      },
      {
        name: "BandiHub Features",
        key: "bandihub-features",
        route: "/dashboard/Casa/BandiHub-Features",
        component: <BandihubFeature />, // You need to import this
      },
      {
        name: "CTA Section",
        key: "cta-section",
        route: "/dashboard/Casa/CTA-Section",
        component: <CtaSection />, // You need to import this
      },
      {
        name: "Form Settings",
        key: "form-settings",
        route: "/dashboard/Casa/Form-Settings",
        component: <FormSettings />, // You need to import this
      },
      {
        name: "Footer Section",
        key: "footer-section",
        route: "/dashboard/Casa/Footer-Section",
        component: <FooterSection />, // You need to import this
      },
      {
        name: "Footer Links",
        key: "footer-links",
        route: "/dashboard/Casa/Footer-Links",
        component: <FooterLink />, // You need to import this
      },
    ],
  },

  // {
  //   type: "collapse",
  //   // name: "Requests 3",
  //   name: "Richieste",
  //   key: "request-list",
  //   icon: <Icon fontSize="small">description</Icon>,
  //   route: "/request/list3",
  //   // component: <RequestList3 />,
  //   collapse: [
  //     {
  //       name: "New Request",
  //       key: "new-request",
  //       route: "/request/new",
  //       component: <NewRequest />,
  //     },
  //     {
  //       name: "Request Types",
  //       key: "request-types",
  //       route: "/request/types",
  //       component: <RequestList2 />,
  //     },
  //     {
  //       name: "Request Categories",
  //       key: "request-categories",
  //       route: "/request/categories",
  //       component: <ListCategory />,
  //     },
  //   ],
  // },

  {
    type: "collapse",
    name: "Change Password",
    key: "dashboard/change-password",
    icon: <Icon fontSize="small">password</Icon>,
    route: "/dashboard/change-password",
    component: <ChangePassword />,
    requiredRole: 'suser',
  },

  {
    type: "collapse",
    // name: "Log Out",
    name: "Logout",
    key: "authentication/log-out",
    icon: <Icon fontSize="small">logout</Icon>,
    route: "/authentication/log-out",
    component: <LogOut />,
  },
  // {
  //   type: "collapse",
  //   // name: "Log Out",
  //   name: "requestList",
  //   key: "authentication/requestList",
  //   // icon: <Icon fontSize="small">logout</Icon>,
  //   route: "/authentication/requestList",
  //   component: <RequestList4 />,
  // },


];


// const routes = [
//   {
//     type: "collapse",
//     name: "Dashboard",
//     key: "dashboard",
//     icon: <Icon fontSize="small">dashboard</Icon>,
//     route: "/dashboard",
//     component: <Dashboard />,
//   },
//   {
//     type: "collapse",
//     name: "Requests",
//     key: "requests",
//     icon: <Icon fontSize="small">description</Icon>,
//     route: "/request",
//     component: <RequestList />,
//     collapse: [
//       {
//         name: "New Request",
//         key: "new-request",
//         route: "/request/new",
//         component: <NewRequest />,
//       },
//       {
//         name: "Request Types",
//         key: "request-types",
//         route: "/request/types",
//         component: <RequestList />,
//       },
//       {
//         name: "Request Categories",
//         key: "request-categories",
//         route: "/request/categories",
//         component: <RequestList />,
//       },
//     ],
//   },
// ];


export default routes;
